import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisonData = [{
  without: 'Apuntes sueltos de mil fuentes',
  with: '6 tomos organizados y completos'
}, {
  without: 'Vías metabólicas que se olvidan',
  with: 'Mapas visuales que se entienden'
}, {
  without: 'Cero organización de cursada',
  with: 'Planner y cronograma incluidos'
}, {
  without: 'Material genérico de otras carreras',
  with: '100% enfocado en Bioquímica'
}, {
  without: 'Estudiás bajo presión de último momento',
  with: 'Sistema pensado cuatrimestre a cuatrimestre'
}];
export function Comparison() {
  return <section className="bg-brand-light py-16 px-4 sm:px-6 lg:px-8" data-id="element-55">
      <div className="max-w-2xl mx-auto" data-id="element-56">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-2xl font-bold text-center text-brand-dark mb-8" data-id="element-57">
          Sin BioKit vs. Con BioKit
        </motion.h2>

        <div className="bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-58">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-59">
            <div className="p-4 text-center font-bold text-gray-500 text-sm flex items-center justify-center gap-2" data-id="element-60">
              <X className="w-4 h-4 text-red-500" data-id="element-61" /> Sin BioKit
            </div>
            <div className="p-4 text-center font-bold text-brand-dark text-sm flex items-center justify-center gap-2 bg-brand-teal/10" data-id="element-62">
              <Check className="w-4 h-4 text-brand-teal" data-id="element-63" /> Con BioKit
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-64">
            {comparisonData.map((row, idx) => <motion.div key={idx} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="grid grid-cols-2" data-id="element-65">
                <div className="p-4 text-sm text-gray-500 flex items-center font-medium" data-id="element-66">
                  {row.without}
                </div>
                <div className="p-4 text-sm text-brand-dark font-bold bg-brand-teal/5 flex items-center" data-id="element-67">
                  {row.with}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}